@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;

.root {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.modes {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    padding: 0 24px;

    @media (max-width: 768px) {
        padding: 0 16px;
        flex-direction: column;
    }
}

.actions {
    display: flex;
    align-items: center;
    padding: 0 24px;

    button.addTransport {
        color: v.$palette-white;
        background-color: v.$palette-orange-2;

        @media (pointer: fine) {
            &:hover {
                color: v.$palette-white;
                background-color: v.$palette-orange-3;
            }
        }
    }

    @media (max-width: 768px) {
        padding: 0 16px;
    }
}

.panel {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px 0;
    background-color: v.$palette-white;
    border-radius: 16px;
    box-shadow: v.$shadow2;

    @media (max-width: 768px) {
        padding: 16px 0;
        border-radius: 12px;
        gap: 16px;
    }
}

.header {
    display: flex;
    align-items: center;
    padding: 0 24px;

    @media (max-width: 768px) {
        padding: 0 16px;
    }
}

.title {
    margin: 0;
    @include t.text(18px, 28px, 600);
    color: v.$palette-gray-900;
}

.list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
